import { BaseEntity, Column, CreateDateColumn, Entity, Index, JoinColumn, ManyToOne, OneToMany, OneToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { FgStatusEnum, GlobalStatus, PassOrFail, PlantsEnum, QualityTypeEnum, SubPlantCodesEnum } from "@gtpl/shared-models/common-models";


@Entity("lot_code_data")

export class LotCodeOpsEntity {

    @PrimaryGeneratedColumn("increment",{name:'lot_code_id'})
    lotCodeOpsId:number;

    @Column({
        nullable: false,
        name: "grn_date"
        })
        grnDate: Date;
    
        @Column({
            type: 'int',
            nullable: true,
            default: 0,
            name: 'plant_id'
        })
        plantId: number;

        @Column({
            type: 'int',
            nullable: true,
            default: 0,
            name: 'sub_plant_id'
        })
        subPlantId: number;
    
        // @Column({
        //     type: 'enum',
        //     enum: SubPlantCodesEnum,
        //     nullable: true,
        //     default: SubPlantCodesEnum.KDM,
        //     name: 'sub_plant_id'
        // })
        // subPlantId: SubPlantCodesEnum;
    
        @Column("int", {
            nullable: false,
            name: "indent_no"
        })
        indentId: number;
        @Column("varchar", {
            nullable: false,
            length: 30,
            name: "grn_number"
        })
        grnNumber: string;
        @Column("varchar", {
            nullable: false,
            length: 30,
            name: "lot_number"
        })
        lotNumber: string;
         @Column("int", {
            nullable: true,
            name: "sale_order_id"
        })
        saleOrderId: number;
        @Column("int", {
            nullable: true,
            name: "sale_order_item_id"
        })
        saleOrderItemId: number;
        @Column("varchar", {
            nullable: false,
            length: 30,
            name: "supplier_type"
        })
        supplierType: string;
        @Column("int", {
            nullable: true,
            name: "farmer"
        })
        farmer: number;
        @Column("int", {
            nullable: false,
            name: "farmer_code"
        })
        farmerCode: number;
        @Column("int", {
            nullable: true,
            name: "quantity"
        })
        quantity: number;
        @Column("int", {
            nullable: true,
            name: "count"
        })
        count: number;
        @Column("int", {
            nullable: true,
            name: "price"
        })
        price: number;
        @Column("int", {
            nullable: true,
            name: "boxes"
        })
        boxes: number;
    
      @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
        })
      isActive:boolean;
      
      @CreateDateColumn({
        name: "created_at",
        type:"datetime"
      })
      createdAt: Date;
    
      @Column("varchar", {
        nullable: false,
        name: "created_user",
        length:50
    })
    createdUser: string | null;
    
    
      @UpdateDateColumn({
          name: "updated_at",
          type:'datetime'
      })
      updatedAt: Date;
    
      @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length:50
    })
    updatedUser: string | null;
    
    
      @VersionColumn({
          default:1,
          name: "version_flag"
      })
      versionFlag: number;

      @Column('int',{
        name:'year'
      })
      year:number

      @Column("varchar", {
        nullable: true,
        length: 50,
        name: "grading_test_result"
    })
    testResult: PassOrFail;
    

      @Column('boolean',{
        name:'lot_club_status',
        nullable:true
      })
      lotClubStatus : boolean

      @Column('varchar',{
        name:'clubbed_main_lot',
        length:20,
        nullable:true
      })
      clubbedMainLot : string

      @Column('varchar',{
        name:'main_lot_number',
        length:30,
        nullable:false
      })
      mainLotNum : string

      @Column('varchar',{
        name:'main_lot_after_club',
        length:30,
        nullable:false
      })
      mainLotAfterClub : string

      //Antibiotic Test Result At GRN
      @Column("varchar", {
        nullable: true,
        length: 50,
        name: "grn_test_result"
      })
      grnTestResult: PassOrFail;

      @Column('decimal',{
        name:'sample_yield',
        nullable:true,
        precision:10,scale:3
      })
      sampleYield : number

    @Column('enum',{
        name:'quality',
        nullable:true,
        enum:QualityTypeEnum
    })
    quality : QualityTypeEnum

    @Column('int',{
        name:'variant_id',
        nullable:false,
    })
    variantId : number

    @Column('varchar',{
        name:'work_order_no',
        length:30,
        nullable:true
    })
    workOrderNo : string




}

